import * as formats from "../../../../common/formats";

require('select2');
require('tempusdominus-bootstrap-4');

$(() => {
    if (document.getElementById('client-contract-list') != null) {

        $('.js-watch').on('click', function(event) {
            let button = $(this);
            let contract_id = button.find('input:hidden[name="contract_id"]').val();
            let user_id = button.find('input:hidden[name="user_id"]').val();

            $.ajax({
                type: 'POST',
                url: '/client/contract/edit/watch',
                data: {
                    'id': user_id,
                    'contract_id' : contract_id
                },
                dataType: 'json', //json形式で受け取る
            }).done(function (data) {
                if(data) {
                    console.log(button);
                    // ウォッチ開始
                    button.find('i').removeClass('text-light').addClass('text-secondary');
                }
                else {
                    // ウォッチ解除
                    button.find('i').removeClass('text-secondary').addClass('text-light');
                }
            });
        });
    }
});